import { gql } from '@apollo/client';

export const DELETE_REPORT_GEN_CONFIG = gql`
  mutation DeleteReportGenConfigs($reportGenConfigDeleteDto: ReportGenConfigDeleteDto!) {
    deleteReportGenConfigs(reportGenConfigDeleteDto: $reportGenConfigDeleteDto) {
      affected
      success
      errorMessage
    }
  }
`;
